
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"52","height":"52","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13 3.25c-2.673 0-4.875 2.202-4.875 4.875v35.75c0 2.673 2.202 4.875 4.875 4.875h26c2.673 0 4.875-2.202 4.875-4.875V16.25H35.75c-2.673 0-4.875-2.202-4.875-4.875V3.25H13zm21.125 0v8.125c0 .928.697 1.625 1.625 1.625h8.125c0-.43-.171-.844-.476-1.149l-8.125-8.125a1.625 1.625 0 00-1.149-.476zM26 19.541a1.625 1.625 0 011.625 1.625v4.875H32.5a1.625 1.625 0 110 3.25h-4.875v4.875a1.625 1.625 0 11-3.25 0v-4.875H19.5a1.625 1.625 0 110-3.25h4.875v-4.875A1.625 1.625 0 0126 19.541z","fill":"#0CF"}}),_c('path',{attrs:{"d":"M13 3.25c-2.673 0-4.875 2.202-4.875 4.875v35.75c0 2.673 2.202 4.875 4.875 4.875h26c2.673 0 4.875-2.202 4.875-4.875V16.25H35.75c-2.673 0-4.875-2.202-4.875-4.875V3.25H13zm21.125 0v8.125c0 .928.697 1.625 1.625 1.625h8.125c0-.43-.171-.844-.476-1.149l-8.125-8.125a1.625 1.625 0 00-1.149-.476zM26 19.541a1.625 1.625 0 011.625 1.625v4.875H32.5a1.625 1.625 0 110 3.25h-4.875v4.875a1.625 1.625 0 11-3.25 0v-4.875H19.5a1.625 1.625 0 110-3.25h4.875v-4.875A1.625 1.625 0 0126 19.541z","fill":"url(#icon-add-file_svg__paint0_linear_4351_14756)","fill-opacity":".2"}}),_c('defs',[_c('linearGradient',{attrs:{"id":"icon-add-file_svg__paint0_linear_4351_14756","x1":"26","y1":"3.25","x2":"26","y2":"48.75","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#fff","stop-opacity":"0"}}),_c('stop',{attrs:{"offset":".984","stop-color":"#006CA9"}})])])])
          )
        }
      }
    